import script from "./StarsReitnig.vue?vue&type=script&setup=true&lang=js"
export * from "./StarsReitnig.vue?vue&type=script&setup=true&lang=js"

import "./StarsReitnig.vue?vue&type=style&index=0&id=0b9e8112&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b9e8112"]])

export default __exports__